import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { EmailRestService } from '../../../services/mail/email-rest.service';
import { EmailSendRequest } from '../../../services/mail/models';

@Component({
    selector: 'app-email-modal',
    templateUrl: './email-modal.component.html'
})
export class EmailModalComponent implements OnInit {
    @Input() public bookId: string = '';
    @Input() public pdfUrl: string = '';
    @Input() public consolidator: string = '';

    public to_address: string = ''; // Indirizzo email destinatario
    public isLoading: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private emailRestService: EmailRestService,
        private translateService: TranslateService
    ) { }

    public ngOnInit(): void {
        console.log('ngOnInit - bookId:', this.bookId, 'pdfUrl:', this.pdfUrl, 'consolidator:', this.consolidator);
    }

    public send(): void {
        // Validazione base
        if (!this.to_address || !this.to_address.trim()) {
            alert(this.translateService.instant('EMAIL_MODAL.INVALID_EMAIL'));
            return;
        }

        // Validazione formato email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.to_address)) {
            alert(this.translateService.instant('EMAIL_MODAL.INVALID_EMAIL'));
            return;
        }

        this.isLoading = true;

        const emailRequest: EmailSendRequest = {
            clientCode: this.consolidator,
            to_address: this.to_address.trim(),
            bookingId: this.bookId,
            pdf_url: this.pdfUrl
        };

        console.log('Invio email con dati:', emailRequest);

        // Invio email tramite il service
        this.emailRestService.sendEmail(emailRequest).subscribe({
            next: (response) => {
                this.isLoading = false;
                if (response.status === 'SUCCESS') {
                    alert('✓ ' + response.message);
                    this.activeModal.close({
                        success: true,
                        to_address: this.to_address,
                        bookingId: response.bookingId
                    });
                } else {
                    const unknown = this.translateService.instant('EMAIL_MODAL.ERROR_UNKNOWN');
                    const prefix = this.translateService.instant('EMAIL_MODAL.ERROR_SEND_FAILED');
                    alert('✗ ' + prefix + ': ' + (response.message || unknown));
                }
            },
            error: (error) => {
                this.isLoading = false;
                console.error('Errore invio email:', error);

                let errorMessage = this.translateService.instant('EMAIL_MODAL.ERROR_GENERIC');
                if (error.status === 0) {
                    errorMessage = this.translateService.instant('EMAIL_MODAL.ERROR_SERVER');
                } else if (error.status === 401) {
                    errorMessage = this.translateService.instant('EMAIL_MODAL.ERROR_AUTH');
                } else if (error.status === 400) {
                    errorMessage = this.translateService.instant('EMAIL_MODAL.ERROR_INVALID_DATA');
                } else if (error.error?.message) {
                    errorMessage = error.error.message;
                }

                alert('✗ ' + errorMessage);
            }
        });
    }
}
